import { render, staticRenderFns } from "./ChbPortChargesFormTable.vue?vue&type=template&id=107febb0&scoped=true"
import script from "./ChbPortChargesFormTable.vue?vue&type=script&lang=js"
export * from "./ChbPortChargesFormTable.vue?vue&type=script&lang=js"
import style0 from "./ChbPortChargesFormTable.vue?vue&type=style&index=0&id=107febb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107febb0",
  null
  
)

export default component.exports